import React from "react";
import { useTheme } from "@mui/material/styles";
import { ImageContainer, StyledImage, Overlay } from "./ImageBox.styles";
import { Variants, Overlays } from "./ImageBox.variants";

export interface CustomImageBoxProps {
  variant?: "sessionCard" | "header" | "squared" | "allocationCard" | "allocationTableHeader";
  src?: string | null;
  overlay?: boolean;
  alt?: string | null;
  showLogoFallback?: boolean;
}

const logoLocation = "/images/logo-new.svg";

export const ImageBox = ({
  variant = "sessionCard",
  src = null,
  overlay = true,
  alt = "",
  showLogoFallback = true,
  ...rest
}: CustomImageBoxProps) => {
  const theme = useTheme();
  const variantStylesFn = Variants(theme);
  const overlayStylesFn = Overlays(theme);

  return (
    (src || showLogoFallback) ? (    
      <ImageContainer
        sx={{
          ...variantStylesFn[variant],
        }}
        className={!src ? "no-src" : ""}
        {...rest}
      >
        <StyledImage
          src={src ? src : logoLocation}
          alt="Show Image"
          fill={true}
          draggable={false}
        />

        {overlay && (
          <Overlay
            sx={{
              ...overlayStylesFn[variant],
            }}
          />
        )}
      </ImageContainer>
    ) : null
  );
};

export interface ImageBoxProps extends React.ComponentProps<typeof ImageBox> {
  as?: React.ElementType;
}

ImageBox.displayName = "ImageBox";
